import React, { useState, useEffect } from "react";
import classes from "./styles.module.scss";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import PrimaryButton from "../../../components/buttons";
import InputText from "../../../components/form/inputText";
import { useGetCounselorListQuery } from "../../../pages/counsellorAdminPage/counsellorAdminApiSlice";
import CheckboxMentor from "./CheckboxMentor";

const style = {
    position: "absolute",
    top: "7vh",
    right: "0px",
    borderRadius: 4,
    p: 0,
    outline: "none",
    backgroundColor: "#fff",
    overflow: "scroll",
    bottom: "10px",
};

const AssignMentorModal = (props) => {
    const [mentorList, setMentorList] = useState([]);
    const [search, setSearch] = useState("");

    const { data: counselorListData } = useGetCounselorListQuery({
        page: 1,
        items: 100000,
        filters: {
            search: "",
            filters: {},
            sort: { column: "id", order: "desc" },
        },
    });


    useEffect(() => {
        if (counselorListData?.rows) {
            setMentorList(counselorListData.rows);
        }
    }, [counselorListData]);

    useEffect(() => {
        if (counselorListData?.rows) {
            const filtered = counselorListData.rows.filter((u) =>
                u.name.toLowerCase().includes(search.toLowerCase())
            );

            const assignedSet = new Set(props.assignData);
            const sorted = filtered.sort((a, b) => {
                const aAssigned = assignedSet.has(a.id);
                const bAssigned = assignedSet.has(b.id);
                if (aAssigned && !bAssigned) return -1;
                if (!aAssigned && bAssigned) return 1;
                return 0;
            });

            setMentorList(sorted);
        } else {
            setMentorList([]);
        }
    }, [search, counselorListData, props.assignData]);



    const handleCheckboxClick = (mentorId) => {
        const id = Number(mentorId);
        props.setAssignData((prev) => {
            if (prev.includes(id)) {
                return prev.filter((item) => item !== id);
            } else {
                return [...prev, id];
            }
        });
    };


    return (
        <div className={classes.assign_checker_modal}>
            <Modal open={props.open} onClose={props.close}>
                <Box sx={style}>
                    <div className={classes.assign_checker_modal_container}>
                        <div className={classes.assign_checker_modal_header}>
                            <p>Assign Mentor</p>
                            <div className={classes.action_buttons}>
                                <PrimaryButton
                                    buttonText="Assign Mentor"
                                    onClick={() => props.handleAssignMentor(props.assignData)}
                                />
                            </div>
                        </div>
                        <div className={classes.assign_checker_modal_body}>
                            <InputText
                                label=""
                                type="text"
                                value={search}
                                name="search"
                                required
                                placeholder="Search"
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <br />
                            <div style={{ height: "75vh", overflowY: "scroll" }}>
                                {mentorList.map((mentor, index) => (
                                    <CheckboxMentor
                                        key={mentor.id}
                                        checker_name={mentor.name}
                                        id_={mentor.id}
                                        for_={mentor.id}
                                        value={mentor.id}
                                        onClick={handleCheckboxClick}
                                        selected={props.assignData.includes(mentor.id)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default AssignMentorModal;
